import { IReference, ReferenceType } from '@common/types';
import { Button } from '@components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@components/ui/dropdown-menu';
import useIsMobile from '@hooks/use-is-mobile';
import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ISourcesDropdownProps {
  references?: Array<IReference>;
}

function SourcesDropdown(props: ISourcesDropdownProps) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  if (props.references?.length) {
    const referencesWithExternalLinks = Array.from(
      new Map(props.references.map((item) => [item.sourceDocumentId, item])).values()
    ).filter((ref) => ref.externalDocumentLink.trim().length > 0);

    if (!referencesWithExternalLinks.length) {
      return null;
    }

    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            className="bg-slate-200 border-none text-black/90 hover:bg-slate-500 hover:text-slate-100 w-full follow-up-buttons"
            variant="outline"
            size={isMobile ? 'sm' : 'default'}
          >
            {t('common.sources')} <ChevronDown />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-full">
          {referencesWithExternalLinks.map((ref, idx) => (
            <DropdownMenuItem key={ref.sourceDocumentId}>
              <a href={ref.externalDocumentLink} target="_blank" className="text-xs sm:text-base">
                {`[${idx}] ${[ReferenceType.Smpc, ReferenceType.Leaflet].includes(ref.referenceType) ? t(`common.${ref.referenceType}`) + ': ' : ''}${ref.name}`}
              </a>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }
  return null;
}

export default SourcesDropdown;
